import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NomenclatureAccountRequest, NomenclatureAccountResponse } from 'src/app/models/nomenclature.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { BudgetService } from 'src/app/services/bugdet.service';

@Component({
  selector: 'app-nomenclature',
  templateUrl: './nomenclature.component.html',
  styleUrls: ['./nomenclature.component.scss']
})
export class NomenclatureComponent implements OnInit {

  nomenclature: NomenclatureAccountResponse[] = [];
  toDelete: NomenclatureAccountResponse = null;
  createMode = false;

  constructor(
    private budgetService: BudgetService,
    private toastService: ToastrService,
    private accountService: AccountService
  ) {

  }

  ngOnInit(): void {
    this.getNomenclature();
  }

  getNomenclature() {
    this.budgetService.getNomenclatureByAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.nomenclature = response.data;
        this.showOrCollapseAll(this.nomenclature);
      },
      error: (error) => {
        this.toastService.error("Error al obtener la nomenclatura");
      }
    })
  }

  showOrCollapseAll(noms: NomenclatureAccountResponse[], isShow = true) {
    noms.forEach(element => {
      element.show = isShow;
      if (element.children.length > 0) {
        this.showOrCollapseAll(element.children, isShow);
      }
    });
  }

  delay(parent: any[], index) {
    parent.splice(index, 1);
    this.createMode = false;
  }

  deleteAccount() {
    this.toDelete.deleting = true;
    if (this.toDelete) {
      this.accountService.deleteAccount(this.toDelete.id).subscribe({
        next: (response: ResponseObject) => {
          this.toDelete = null;
          this.getNomenclature();
        },
        error: (error) => {
          this.toDelete.deleting = false;
          this.toastService.error("Error al eliminar la nomenclatura");
        }
      })
    }
  }

  create(newAccount: NomenclatureAccountResponse, parent: NomenclatureAccountResponse) {
    if (newAccount.creating) {
      return;
    }
    if (!newAccount.balance || !newAccount.name || !newAccount.displayId) {
      this.toastService.info("Completa todos los campos");
      return;
    }
    newAccount.creating = true;
    var request = new NomenclatureAccountRequest();
    request.balance = newAccount.balance + "";
    request.displayId = newAccount.displayId;
    request.name = newAccount.name;
    request.parentId = newAccount.id ? newAccount.id : parent.id;
    this.accountService.createOrEditAccount(request, request.parentId != parent.id).subscribe({
      next: (response: ResponseObject) => {
        newAccount.creating = false;
        this.createMode = false;
        this.toastService.success("Cuenta " + (request.parentId != parent.id ? 'editada' : 'creada') + " exitosamente!");
        this.getNomenclature();
      },
      error: (error) => {
        newAccount.creating = false;
        this.createMode = false;
        this.toastService.error("Error al crear la cuenta");
      }
    });
  }

  addCategory(parent) {
    if (!this.createMode) {
      parent.show = true;
      var newCategory = new NomenclatureAccountResponse();
      newCategory.children = [];
      newCategory.temporal = true;
      newCategory.balance = 1;
      parent.children.unshift(newCategory);
    } else {
      this.toastService.info("Termina de crear la cuenta anterior");
    }
    this.createMode = true;
  }

}
